import Rolling from '@assets/gif/rolling.gif';
import { ClickAwayListener } from '@material-ui/core';
import { ITag } from '@models/Tag.model';
import { Tag } from '@components/Tag/Tag';
import React from 'react';

import {
  LoadingImg,
  Search,
  SearchButton,
  SearchContainer,
  SearchImg,
  StyledOption,
  Container,
  ShowOptions,
  Div,
} from './SearchBarExpansiveTags.styles';
import { CloseBtn } from './CloseBtn';

interface SearchBarProps {
  showOptions: ITag[];
  searchText: string;
  placeholder: string;
  loadingSearch: boolean;
  alreadySearch: boolean;
  showErasedSearch: boolean;
  searchOnKeyDown: (event: any) => void;
  searchIconOnClick: () => void;
  closeIconOnClick: () => void;
  onClickFilter: (input: ITag) => void;
  searchOnChange: any;
  setShowOptions: (input: ITag[]) => void;
}
const SearchBarExpansiveTags = ({
  searchText,
  placeholder,
  setShowOptions,
  searchOnChange,
  searchOnKeyDown,
  loadingSearch,
  showErasedSearch,
  searchIconOnClick,
  closeIconOnClick,
  alreadySearch,
  showOptions,
  onClickFilter,
}: SearchBarProps) => {
  const handleClickAway = () => {
    if (showOptions.length > 0) setShowOptions([]);
  };
  return (
    <Div>
      <SearchContainer>
        <SearchImg />
        <Search
          haveResults={showOptions ? showOptions.length > 0 : false}
          value={searchText}
          placeholder={placeholder}
          onChange={e => searchOnChange(e.target.value)}
          onKeyDown={searchOnKeyDown}
          autoComplete="off"
        />
        {loadingSearch && <LoadingImg src={Rolling} alt="loading" />}
        {showErasedSearch && searchText.length > 0 && !loadingSearch && (
          <CloseBtn onClick={closeIconOnClick} />
        )}
        {!loadingSearch &&
          !showErasedSearch &&
          (searchText.length > 0 || alreadySearch) && (
            <SearchButton onClick={searchIconOnClick}>Search</SearchButton>
          )}
      </SearchContainer>
      <ClickAwayListener onClickAway={handleClickAway}>
        <ShowOptions haveResults={showOptions.length > 0}>
          <Container haveResults={showOptions.length > 0}>
            {showOptions.map(item => (
              <StyledOption
                onClick={() => {
                  onClickFilter(item);
                }}
              >
                <Tag
                  id={item.id}
                  tagName={item.name}
                  tagCategory={item.tagCategory?.name}
                  color={item.tagCategory?.color}
                />
              </StyledOption>
            ))}
          </Container>
        </ShowOptions>
      </ClickAwayListener>
    </Div>
  );
};

export { SearchBarExpansiveTags };
